import React from "react";
import { FiTrash2 } from "react-icons/fi";
import { formatDateDDMMYYYY } from "../../../Utils";

const BackdatedPermissionMobileCard = ({ data, isHR, onDelete }) => {
  return (
    <div className="border rounded-md shadow-md p-4">
      <div className="flex justify-between items-start gap-2">
        <div className="flex flex-col">
          <span className="font-semibold text-primary">{data.user_name}</span>
          <span className="text-sm text-gray-600">
            {formatDateDDMMYYYY(data.start_date)} -{" "}
            {formatDateDDMMYYYY(data.end_date)}
          </span>
        </div>

        {isHR && (
          <button
            className="text-red-500 hover:text-red-700 p-1 shrink-0"
            title="Revoke"
            onClick={() => onDelete(data.id)}
          >
            <FiTrash2 className="text-lg" />
          </button>
        )}
      </div>

      <div className="mt-3">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Reason
        </span>
        <p className="text-sm text-gray-800 whitespace-pre-wrap break-words mt-0.5">
          {data.reason || "-"}
        </p>
      </div>

      <div className="mt-3 text-xs text-gray-500">
        Granted by{" "}
        <span className="font-medium text-gray-700">
          {data.granted_by_name || "-"}
        </span>
      </div>
    </div>
  );
};

export default BackdatedPermissionMobileCard;
